import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { COMPANY_INFO } from '../data/company';

export function ForbiddenPage() {
  return (
    <>
      <Helmet>
        <title>403 - Adgang nægtet · JNO Montage</title>
      </Helmet>

      <section className="py-24 bg-[#E6EBEF] min-h-[70vh] flex items-center justify-center px-4">
        <div className="max-w-xl mx-auto bg-white p-8 sm:p-12 rounded-3xl border border-gray-200 shadow-xl text-center space-y-6">
          <div className="w-20 h-20 bg-[#206FEA]/10 text-[#206FEA] rounded-full flex items-center justify-center mx-auto text-3xl">
            <i className="fa-solid fa-lock text-red-600" aria-hidden="true"></i>
          </div>

          <div className="space-y-2">
            <span className="text-xs font-bold uppercase tracking-widest text-red-600">Fejl 403</span>
            <h1 className="text-3xl font-extrabold text-[#0B0E14]">Adgang nægtet</h1>
            <p className="text-sm text-slate-600">
              Du har ikke tilladelse til at tilgå denne ressource. Vend venligst tilbage til forsiden eller kontakt os, hvis du mener dette er en fejl.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 pt-2 text-sm font-semibold">
            <Link
              to="/"
              className="flex-1 p-3.5 bg-[#0B0E14] text-white rounded-xl hover:bg-[#192330] transition-colors flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-house" aria-hidden="true"></i>
              <span>Gå til Forsiden</span>
            </Link>

            <Link
              to="/kontakt"
              className="flex-1 p-3.5 bg-[#E6EBEF] text-[#0B0E14] border border-gray-200 rounded-xl hover:border-[#206FEA] transition-colors flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-envelope" aria-hidden="true"></i>
              <span>Kontakt os</span>
            </Link>
          </div>

          <div className="pt-4 border-t border-gray-100 text-xs text-slate-600">
            <span>Spørgsmål? Ring på </span>
            <a href={`tel:${COMPANY_INFO.phoneRaw}`} className="font-extrabold text-[#206FEA] hover:underline whitespace-nowrap">
              {COMPANY_INFO.phone}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
